export default {
  AssignmentPeriod: {
    ListAssessmentPeriod: 'Danh sách kỳ đánh giá',
    Month: 'Tháng {month}',
    CreateAssessment: 'Tạo kỳ đánh giá',
    EditAssessment: 'Sửa kỳ đánh giá',
    DeleteAssessment: 'Xóa kỳ đánh giá',
    Scope: 'Phạm vi',
    ChooseStudent: 'Chọn học sinh',
    Subject: 'Môn',
    ChooseSubject: 'Chọn môn',
    ChooseTeacher: 'Chọn giáo viên soạn đề',
    Date: 'Tháng',
    ChoseDate: 'Chọn tháng',
    Grade: 'Khối',
    ChooseGrade: 'Chọn khối',
    TimeAssessment: 'Thời gian diễn ra',
    Time: 'Thời gian làm bài',
    Detail: 'Chi tiết',
    TimeDetail: '({fromDate} - {toDate})',
    WarningDeleteSubject: 'Giáo viên {teacherName} đã soạn đề kiểm tra cho môn {subjectName}.<br> Bạn có muốn bỏ môn {subjectName} khỏi kỳ đánh giá này không?',
    WarningDeleteMultipleSubject: 'Môn {subjectName} và {number} môn khác đã được soạn đề kiểm tra.<br> Bạn có muốn bỏ những môn này khỏi kỳ đánh giá không?',
    ConfirmDelete: 'Bạn có chắc muốn xóa kỳ đánh giá này không?',
    MessWarning:
      'Giáo viên {teacherName} đã soạn đề cho bài kiểm tra môn {subjectName}.<br>Bạn có chắc muốn xóa kỳ đánh giá này không?',
    MessWarningMultiple:
      'Giáo viên {teacherName} và {number} giáo viên khác đã soạn đề cho bài kiểm tra.<br>Bạn có chắc muốn xóa kỳ đánh giá này không?',
    RefStartTime: 'RefStartTime{id}',
    RefStartTimeHour: 'RefStartTimeHour{id}',
    RefStartTimeDay: 'RefStartTimeDay{id}',
    RefEndTime: 'RefEndTime{id}',
    RefEndTimeHour: 'RefEndTimeHour{id}',
    RefEndTimeDay: 'RefEndTimeDay{id}',
    ErrorStartTime: 'Thời gian mở đề phải nhỏ hơn thời gian đóng đề',
    ErrorEndTime: 'Thời gian đóng đề phải lớn hơn thời gian mở đề',
    ErrorTime: 'Thời gian kết thúc phải lớn hơn thời gian bắt đầu',
    TitleAssessment: 'Tên kỳ đánh giá',
    ChooseTime: 'Chọn thời gian',
    TemplateTime: '{time} phút',
    Classroom: 'Lớp',
    AllClassroomInGrade: 'Tất cả các lớp trong khối',
    ListAssessmentPeriodPlanOfSchool: 'Kế hoạch kiểm tra của nhà trường',
    RoundMark: 'Làm tròn điểm',
    AutoRoundMarkWhenStatistic: 'Tự động làm tròn điểm khi thống kê kết quả',
    MarkRoundToOne: 'Ví dụ: 9.4 -> 9; 9.5 -> 10',
    MarkRoundToZeroDotOne: 'Ví dụ: 9.75 -> 9.8; 9.74 -> 9.7',
    MonthNormal: 'Tháng',
    AssignmentPeriod: 'Kỳ đánh giá',
    Status: 'Trạng thái',
    AllSchoolScope: 'Toàn trường',
    GradeScope: 'Khối {grade}',
    ClassScope: '{classQuantity} lớp',
    StudentScope: '{studentQuantity} học sinh'

  },
  // VHSon
  SchoolExamPeriod: {
    AllClass: 'Tất cả các lớp',
    Scope: 'Phạm vi',
    Monitor: 'Giám sát',
    Statistical: 'Thống kê kết quả',
    AssignMark: 'Phân công chấm bài',
    ExamTopic: 'Đề kiểm tra',
    TeacherComposeTopic: 'Giáo viên soạn đề',
    TimeAmountDoExam: 'Thời gian làm bài',
    TimePeriod: 'Khung thời gian kiểm tra',
    OpenTopicTime: 'Thời gian mở đề',
    CloseTopicTime: 'Thời gian đóng đề',
    CommonInformation: 'Thông tin chung',
    ExamStoreInformation: 'Đề kiểm tra',
    Point: '{Point} điểm',
    LastEditted: 'Chỉnh sửa lần cuối',
    QtyQuestion: 'Số câu',
    PreviewExamStore: 'Chi tiết đề',
    QtyEssay: 'Tự luận',
    QtyMultiChoice: 'Trắc nghiệm',
    MaxPoint: 'Thang điểm',
    NotOpen: 'Chưa diễn ra',
    Processing: 'Đang diễn ra',
    IsOver: 'Đã kết thúc',
    MessageCloseTopicExamPeriod: 'Sau <b>{minuteLeft}</b> phút <b>{secondLeft}</b> giây đến thời gian dự kiến đóng đề.</br>Bạn có chắc muốn đóng đề sớm không?',
    JoinExam: 'Tham gia kiểm tra',
    SubmitRate: 'Tỷ lệ',
    QtySubmit: 'Số lượng',
    AvgPoint: 'Điểm trung bình',
    StudentReady: 'Học sinh sẵn sàng làm bài',
    ViewExamButton: 'Xem đề',
    ViewExamTitle: 'Đề kiểm tra',
    StudentSubmitted: 'Đã nộp bài',
    Joined: 'Đang làm bài',
    IsReady: 'Đang chờ',
    NotJoinYet: 'Chưa tham gia',
    NotJoin: 'Không tham gia',
    ExamStatisticTitle: 'Thống kê số học sinh tham gia kiểm tra',
    Submitted: 'Đã nộp',
    TotalStudentAmount: 'Tổng số học sinh:',
    TotalClassAmount: 'Tổng số lớp học',
    ClassInfo: '{ClassName} - {TotalStudent} học sinh',
    ClassListInfo: '{TotalClass} lớp - {TotalStudent} học sinh',
    StudentInfo: '{TotalStudent} học sinh',
    StudentJoin: 'Thành phần tham gia',
    ExamStoreInfo: 'Thông tin đề kiểm tra',
    ConcentrationExam: 'Làm bài cùng thời điểm',
    DispersionExam: 'Làm bài trong khoảng thời gian',
    StudentName: 'Học sinh ({StudentQty})',
    ExamReorganize: 'Tổ chức kiểm tra bù',
    ReorganizeForNotJoin: 'Tổ chức kiểm tra bù cho tất cả học sinh chưa tham gia',
    ExamHistoryTabTitle: 'Lịch sử kiểm tra',
    OfficialExam: 'Chính thức',
    ReOrganizeAttemp: 'Lần kiểm tra',
    AttempTime: 'Kiểm tra bù lần {time}',
    OrganizeFor: 'Tổ chức cho',
    TotalJoin: 'Số học sinh tham gia',
    OverviewExamPeriod: 'Tổng quan',
    CompensatoryTestList: 'Danh sách bài kiểm tra bù',
    MarkingProgressExamPeriod: 'Tình trạng chấm bài',
    Month: 'Tháng',
    Subject: 'Môn',
    Grade: 'Khối',
    All: 'Tất cả',
    Status: 'Trạng thái',
    ExamTitle: 'Kỳ kiểm tra',
    StudentAmount: 'Sĩ số',
    IsJoin: 'Đã tham gia',
    OpenTime: 'Thời gian mở đề',
    CloseTime: 'Thời gian đóng đề',
    WaitingOpenTopic: 'Chờ mở đề',
    ProcessingStatus: 'Đang kiểm tra',
    YouNeedChooseToOpenExamFromOverview: 'Bạn cần chọn một kỳ đánh giá <b>đã có đề</b> với trạng thái <b>chưa diễn ra</b> hoặc <b>chờ mở đề</b>.',
    ResetStudentNotify: 'Kết quả bài làm của học sinh sau khi hủy sẽ không thể khôi phục, học sinh <b>{studentName}</b> sẽ về trạng thái không tham gia kiểm tra.</br> Bạn có chắc muốn hủy kết quả không?',
    GetNewestData: 'Lấy dữ liệu mới nhất',
    TeacherAnswer: 'Lời giải',
    AssignForGrade: 'Giao cho cả khối',
    MarkingTeacher: 'Giáo viên chấm bài',
    EndDateTimeNotFound: 'Hãy bổ sung thời gian đóng đề.',
    StartEndTimeNotFound: 'Hãy bổ sung thời gian đóng/mở đề.',
    ReadyRouterButton: 'Đường dẫn phòng chờ',
    ReadyRouterTitle: 'Đường dẫn vào phòng chờ',
    ChooseClassWarning: 'Vui lòng chọn đúng lớp để lấy đường dẫn phòng chờ',
    CopyLink: 'Sao chép nội dung bên dưới rồi gửi cho Học sinh lớp',
    CopyLinkStudent: 'Sao chép nội dung bên dưới rồi gửi cho Học sinh',
    ContentCopyShareReadyPopup: 'Học sinh lớp <b>{classRoom}</b> vào <a href={linkTo} target="_blank" style="color: #00a9ec">{linkTo}</a> để tham gia làm bài kiểm tra <b>{examTitle}</b>',
    ContentCopyShareScopeStudentReadyPopup: 'Học sinh vào <a href={linkTo} target="_blank" style="color: #00a9ec">{linkTo}</a> để tham gia làm bài kiểm tra <b>{examTitle}</b>',
    ResetStudentResult: 'Hủy kết quả',
    ChangeStudentExamStatus: 'Cập nhật trạng thái',
    AllowStudent: 'Cho phép học sinh {studentName}:',
    ContinueWhereLeft: 'Làm tiếp bài kiểm tra',
    StartFromBegin: 'Làm lại bài kiểm tra',
    KeepSubmitExam: 'Giữ nguyên bài học sinh đã làm',
    DiscardSubmitExam: 'Hủy bỏ kết quả làm bài cũ của học sinh',
    ResetStatusNotify: 'Bạn có chắc muốn cho phép học sinh <b>{studentName}</b> làm lại bài kiểm tra không?',
    UpdateStatusNotify: 'Bạn có chắc muốn cho phép học sinh <b>{studentName}</b> làm tiếp bài kiểm tra không?',
    UpdateSuccessfulNotify: 'Bạn đã cập nhật thành công',
    OrSendBy: 'hoặc gửi ngay qua',
    ShuffleAmountMustBeNatural: 'Số lượng bộ đề phải là dạng số tự nhiên',
    ShuffleAmountLessThanTen: 'Số lượng bộ đề tối đa là 10',
    ShuffleAmountGreaterThanZero: 'Số lượng bộ đề tối thiểu là 1',
    GradeAndClass: 'Khối lớp',
    LastExamPeriod: 'Kỳ kiểm tra trước',
    ViewBy: 'Xem theo',
    SortBy: 'Sắp xếp theo',
    ChooseExamPeriod: 'Chọn kỳ kiểm tra',
    PointFromHighToLow: 'Điểm từ cao đến thấp',
    PointFromLowToHigh: 'Điểm từ thấp đến cao',
    NotParticipateList: 'Danh sách không tham gia',
    ParticipateList: 'Học sinh tham gia ({amount})',
    PickedAmountStudent: 'Đã chọn {amount} học sinh',
    ShuffleOnlyCompose: 'Vui lòng nhập một đề kiểm tra tự soạn để sử dụng tính năng trộn đề',
    ChooseStudentAlert: 'Vui lòng chọn học sinh'
  },

  // ttdung
  SchoolExamAssign: {
    ListClass: 'Danh sách lớp',
    SelectTeacher: 'Chọn giáo viên',
    GrandingTeacher: 'Giáo viên chấm bài',
    Class: 'Lớp',
    FindTeacher: 'Tìm giáo viên'
  }
}
